<template>
  <div class="calico-ai-response-loader">
    <p
      v-if="step === 1"
      class="body--medium"
    >
      Analyzing...
    </p>
    <p
      v-if="step === 2"
      class="body--medium"
    >
      Thinking...
    </p>
    <p
      v-if="step === 3"
      class="body--medium"
    >
      Generating response...
    </p>
  </div>
</template>

<script>
export default {
  name: 'CalicoAiResponseLoader',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      step: 0
    }
  },
  mounted() {
    setTimeout(() => (this.step = 1), 0)
    setTimeout(() => (this.step = 2), 1000)
    setTimeout(() => (this.step = 3), 2000)
  }
}
</script>

<style lang="scss" scoped>
.calico-ai-response-loader {
  color: $color-text-secondary;
  p {
    opacity: 0;
    animation: fadeIn 1s ease forwards;
  }
  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
}
</style>